import type { SuccessMessage } from '@solidgate/vue-sdk'
import type { CheckoutStore } from './interfaces'

import { AppRoute } from '@ts-routes/enums'

import { resolveOrderId } from '@helpers/kid-id'

const getDetailsUrl = (state: CheckoutStore, solidOrderId: string | null): string | null => {
  if (!solidOrderId) return null

  const orderId = state.order?.id || null
  if (!orderId) return null

  const url = resolveOrderId(AppRoute.Order, orderId)
  if (!url) return null

  return `${url}?solid_order_id=${solidOrderId}`
}

export const actions = {
  setLoading (this: CheckoutStore, payload: CheckoutStore['loading']): void {
    this.loading = payload
  },
  setPaymentLocked (this: CheckoutStore, payload: CheckoutStore['paymentLocked']): void {
    this.paymentLocked = payload
  },
  setBlockPromoCode (this: CheckoutStore, payload: CheckoutStore['blockPromoCode']): void {
    this.blockPromoCode = payload
  },
  setAppliesForPromocode (this: CheckoutStore, payload: CheckoutStore['appliesForPromocode']): void {
    this.appliesForPromocode = payload
  },
  setFurtherPayments (this: CheckoutStore, payload: CheckoutStore['furtherPayments']): void {
    this.furtherPayments = payload
  },
  setOrder (this: CheckoutStore, payload: CheckoutStore['order']): void {
    this.order = payload
  },
  setUpsellOrder (this: CheckoutStore, payload: CheckoutStore['upsellOrder']): void {
    this.upsellOrder = payload
  },
  setPaymentData (this: CheckoutStore, payload: CheckoutStore['paymentData']): void {
    this.paymentData = payload
  },
  setStripeClientSecret (this: CheckoutStore, payload: CheckoutStore['stripeClientSecret']): void {
    this.stripeClientSecret = payload
  },
  setPaypalScriptUrl (this: CheckoutStore, payload: CheckoutStore['paypalScriptUrl']): void {
    this.paypalScriptUrl = payload
  },
  setModalFurtherPayments (this: CheckoutStore, payload: CheckoutStore['modalFurtherPayments']): void {
    this.modalFurtherPayments = payload
  },
  setPaypalScriptReady (this: CheckoutStore, payload: CheckoutStore['paypalScriptReady']): void {
    this.paypalScriptReady = payload
  },
  getPayPalDetailsUrl (this: CheckoutStore, event: any): string | null {
    const solidOrderId = event?.detail?.data?.order?.order_id || null
    return getDetailsUrl(this, solidOrderId)
  },
  getSolidDetailsUrl (this: CheckoutStore, event: SuccessMessage): string | null {
    const solidOrderId = event?.order?.order_id || null
    return getDetailsUrl(this, solidOrderId)
  },
  setPaymentError (this: CheckoutStore, payload: CheckoutStore['paymentError']): void {
    this.paymentError = payload
  },
  setNotifyType (this: CheckoutStore, payload: CheckoutStore['notifyType']): void {
    this.notifyType = payload
  },
  setModalPaymentFailed (this: CheckoutStore, payload: CheckoutStore['modalPaymentFailed']): void {
    this.modalPaymentFailed = payload
  },
  setBillingCountry (this: CheckoutStore, payload: CheckoutStore['billingCountry']): void {
    this.billingCountry = payload
  },
  setBillingZipCode (this: CheckoutStore, payload: CheckoutStore['billingZipCode']): void {
    this.billingZipCode = payload
  },
  setBillingZipStatus (this: CheckoutStore, payload: CheckoutStore['billingZipStatus']): void {
    this.billingZipStatus = payload
  },
  setBillingCountryState (this: CheckoutStore, payload: CheckoutStore['billingCountryState']): void {
    this.billingCountryState = payload
  },
  setBillingConfirmed (this: CheckoutStore, payload: CheckoutStore['billingConfirmed']): void {
    this.billingConfirmed = payload
  },
  setModalFormSolidgate (this: CheckoutStore, payload: CheckoutStore['modalFormSolidgate']): void {
    this.modalFormSolidgate = payload
  },
  setModalCurrentMethodPayment (this: CheckoutStore, payload: CheckoutStore['modalCurrentMethodPayment']): void {
    this.modalCurrentMethodPayment = payload
  },
}
